import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useContentTags } from 'lib/content-tags';
import { getCustomTagNameByIdFor } from 'lib/content-tags/get-custom-tag-name-by-id-for';
import { makeAliasesFromClassAndOrg } from 'lib/content-tags/make-aliases-from';
import keyBy from 'lodash/keyBy';

export const useAliasedContentTags = (contentTags) => {
  const { contentTags: originalTags } = useContentTags();
  const processedContentTags = contentTags ?? originalTags;

  const user = useSelector(({ auth }) => auth.user);

  const aliasedContentTags = useMemo(() => {
    const aliases = makeAliasesFromClassAndOrg(user);
    const customTagNameById = getCustomTagNameByIdFor(aliases);

    return processedContentTags.map((tag) => ({
      ...tag,
      title: customTagNameById[tag._id] ?? tag.displayTitle ?? tag.title,
    }));
  }, [user, processedContentTags]);

  return {
    aliasedContentTags,
    aliasedContentTagsMapById: keyBy(aliasedContentTags, '_id'),
  };
};
